var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel-contanier" }, [
    _c(
      "div",
      { staticClass: "top", style: { height: _vm.height } },
      [
        _c("svg-icon", {
          style: { "font-size": _vm.height },
          attrs: { iconClass: "panel-icon", className: "icon" },
        }),
        _vm.title
          ? _c(
              "span",
              {
                style: {
                  height: _vm.height,
                  "font-size": _vm.fontSize,
                  "line-height": _vm.height,
                },
              },
              [_vm._v(_vm._s(_vm.title))]
            )
          : _vm._t("header"),
      ],
      2
    ),
    _c("div", { staticClass: "panel-content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }